// extracted by mini-css-extract-plugin
export default {"title":"title_title__K81Uf","dark":"title_dark__g-tiS","light":"title_light__s8HIT","accent":"title_accent__TbUFS"};